/* @jsxImportSource @emotion/react */

import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { Section } from '../../components/Section'
import { mediaQuerySmall } from '../../components/style'
import { getWorkCulturePillars } from './data'

export function SectionWorkCulture(props: { background?: string }) {
  const intl = useIntl()
  const workCulturePillars = getWorkCulturePillars(intl)

  return (
    <Section
      background={props.background ?? 'moon-dust'}
      containerVerticalPadding={60}
    >
      <div className="text-align-center padding-bottom-40">
        <div className="font-size-2 font-family-title font-weight-medium">
          <FormattedMessage
            id="jobs.culture.title"
            defaultMessage="We work thoughtfully"
          />
        </div>
        <div className="font-size-6 padding-top-16 shade-05">
          <FormattedMessage
            id="jobs.culture.subtitle"
            defaultMessage="We are not all good at the same things, but that's what makes us strong."
          />
        </div>
      </div>

      <div className="grid-12 grid-gap-24">
        {workCulturePillars.map((pillar) => (
          <div
            key={pillar.title}
            className={classNames(
              'grid-span-6 grid-span-12-small',
              'radius-large',
              `background-${pillar.color}`,
              {
                'border-medium border-shade-00': pillar.color === 'dust',
              }
            )}
            css={{
              [mediaQuerySmall]: {
                gridColumn: 'span 12',
              },
            }}
          >
            <div
              className={classNames(
                'padding-40 height-full',
                ['moon-dust', 'primary'].includes(pillar.color)
                  ? 'white'
                  : 'shade-05'
              )}
              css={{
                [mediaQuerySmall]: {
                  padding: '24px',
                },
              }}
            >
              <img
                height={110}
                className="margin-bottom-40"
                src={pillar.icon}
                alt={pillar.title}
              />
              <div
                className={classNames(
                  'font-size-4 font-family-title font-weight-medium'
                )}
              >
                {pillar.title}
              </div>
              <div
                className={classNames(
                  'font-size-6 padding-top-16 line-height-relaxed'
                )}
                css={{
                  whiteSpace: 'pre-line',
                }}
              >
                {pillar.description}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}
